import React, { PureComponent, Fragment } from 'react';
import { NAVIGATOR_HEIGHT } from './utils';
// Components
import styles from './chart.scss';
import Mouse from 'core/mouse';

interface ChartNavigatorRangeProps {
  range: [number, number];
  width: number;
  onChange: (range: [number, number]) => void;
}
export default class ChartNavigatorRange extends PureComponent<ChartNavigatorRangeProps> {
  handleDragStart = e => {
    e.preventDefault();
    e.stopPropagation();
    Mouse.on('mousemove', this.handleDrag);
    Mouse.on('mouseup', this.handleDragEnd);
    this.initRange = this.props.range;
  };

  handleDrag = () => {
    const [start, end] = this.initRange;
    const dOffset = Math.min(1 - end, Math.max(-start, Mouse.getDownDistX() / this.props.width));
    this.props.onChange([start + dOffset, end + dOffset]);
  };

  handleDragEnd = () => {
    Mouse.off('mousemove', this.handleDrag);
    Mouse.off('mouseup', this.handleDragEnd);
  };
  render() {
    const { width: navigatorWidth, range } = this.props;

    const x = navigatorWidth * range[0];
    const width = navigatorWidth * (range[1] - range[0]);
    return (
      <Fragment>
        <rect x={x} width={width} height={NAVIGATOR_HEIGHT} className={styles.range} />
        <rect className={styles.dragHandle} onMouseDown={this.handleDragStart} width={7} height={24} y={12} x={x + width / 2 - 10/2}></rect>
      </Fragment>
    );
  }
}
